import React from 'react'

import { HStack, Text } from 'govwell-ui'

type LegendItem = {
  label: string
  color: string
}

type Props = {
  items: LegendItem[]
}

const ChartLegend = ({ items }: Props) => {
  return (
    <HStack gap={4} width="auto">
      {items.map((item) => (
        <HStack key={item.label} gap={2} align="center" className="whitespace-nowrap">
          <div className="h-3 w-3 rounded-sm" style={{ backgroundColor: item.color }} />
          <Text.BodySmall className="text-gray-500">{item.label}</Text.BodySmall>
        </HStack>
      ))}
    </HStack>
  )
}

export default React.memo(ChartLegend)
